<template>
  <div class="selectables">
    <b-form-group>
      <template #label>
        <b>Escoge los Servicios que deseas asignar:</b><br />
        <b-form-checkbox
          aria-describedby="serviceOptions"
          aria-controls="serviceOptions"
          @change="toggleAll"
        >
          Seleccionar Todos
        </b-form-checkbox>
      </template>

      <template v-slot="{ ariaDescribedby }">
        <b-form-checkbox-group
          id="serviceOptions"
          v-model="selected"
          :options="serviceOptions"
          :aria-describedby="ariaDescribedby"
          name="serviceOptions"
          class="ml-4"
          aria-label="Individual serviceOptions"
          stacked
        ></b-form-checkbox-group>
      </template>
    </b-form-group>
  </div>
</template>
<script>
import axios from "axios";
export default {
  props: ["selectedMinister", "selectedServicesToAdd"],
  data() {
    return {
      serviceOptions: null,
      selected: [],
    };
  },
  watch: {
    selectedMinister: function() {
      console.clear();
      this.selected = [];
      this.requestMinisterServices();
    },
    selected: function() {
      this.selectedServicesToAdd(this.selected);
    }
  },
  methods: {
    toggleAll(checked) {
      this.selected = checked ? this.serviceOptions.map(s => s.value) : [];
    },
    requestMinisterServices: async function() {
      const res = await axios.get(
        `${process.env.VUE_APP_RUTA_API}/instituciones/ministerios/${this.selectedMinister}/`
      );

      this.serviceOptions = res.data.servicios.map((s) => ({
        value: s.id,
        text: s.nombre,
      }));
    },
  },
  mounted() {
    this.requestMinisterServices();
  },
};
</script>
<style >
.selectables {
  background: #e0e0e0;
  padding: 10px;
  margin: 0 40px;
}
label.custom-control-label {
  margin: 0 3px !important;
  font-size: .8rem;
}
#__BVID__468__BV_label_ > b {
  font-size: .9rem;
}
</style>
